import produce from 'immer';

import moment from 'moment';
import {
    ITEM_BOX_LOG_LIST,
    ITEM_BOX_LOG_LIST_REQUEST,
    SET_ITEM_BOX_LOG_PAGINATION,
    SET_TOTAL_COUNT
} from "../../constants/log/itemBoxLogConstants";

const initialState = {
    page: 1,
    pageLength: 10,
    beginDate: moment().utc().subtract(3, 'days').format('YYYY-MM-DDT00:00:00'),
    endDate: moment().utc().format('YYYY-MM-DDT23:59:59'),
    searchCode: '',
    searchString: '',
    totalCount: 0,
};

const itemBoxLogReducer = (state = initialState, action = {}) => produce(state, draft => {
    switch (action.type) {
        case ITEM_BOX_LOG_LIST_REQUEST:
            break;
        case ITEM_BOX_LOG_LIST:
            draft.list = action.list;
            break;
        case SET_TOTAL_COUNT:
            draft.totalCount = action.totalCount;
            break;
        case SET_ITEM_BOX_LOG_PAGINATION:
            draft.page = action.page;
            draft.totalCount = action.totalCount;
            draft.beginDate = action.beginDate;
            draft.endDate = action.endDate;
            draft.searchCode = action.searchCode;
            draft.searchString = action.searchString;
            break;
        default:
            break;
    }
});

export default itemBoxLogReducer;
